import { gql } from '@apollo/client';

export const UPDATE_PRICING_SCHEME = gql`
  mutation UpdatePricingSchemeByClientId($input: PricingSchemeInput!) {
    updatePricingSchemeByClientId(input: $input) {
      success
      message
      data
      messageKey
    }
  }
`;

export interface UpdatePricingSchemeResponse {
  updatePricingSchemeByClientId: { success: boolean; message: string; data?: string | null; messageKey?: string | null };
}

